import axios from 'axios';

export default {
  name: 'VueCalculator',
  data() {
    return {
      currentStep: 0,
      domainUrl: '',
      errorMessage: '',
      fields: {},
      info: {},
      isValid: true,
      mainTarget: '',
      results: {},
      seedVariety: '',
      showFactors: false,
      showNoResultsMessage: false,
      steps: [],
      submitted: false,
      targetSelected: '',
      target: '',
    };
  },
  computed: {
    totalSteps() {
      return this.steps.length;
    },
    isFirstStep() {
      return this.currentStep === 0;
    },
    isLastStep() {
      return this.currentStep === this.totalSteps - 1;
    },
    resultsLoaded() {
      return this.submitted && this.results.product && this.results.estimates;
    },
  },
  created() {
    const config = {
      params: {
        type: 'estimate-myseed',
      },
    };

    // Get domain URL from main div attribute.
    this.domainUrl = document
      .getElementById('vue-calculator')
      .getAttribute('data-domain-url');

    const url = `${this.domainUrl}/calculator/steps-fields/`;
    axios
      .get(url, config)
      .then((response) => {
        this.fields = response.data.fields || {};
        this.steps = response.data.steps || [];

        // By default, first seed variety should be selected.
        this.seedVariety = this.fields.seed_variety.options[0].value || null;

        // By default, select first target option.
        const firstTargetKey = Object.keys(this.fields.target.options).shift();
        this.mainTarget = firstTargetKey;
        this.targetSelected = firstTargetKey;
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    getPlaceholder(field) {
      return field.attributes && field.attributes.placeholder
        ? field.attributes.placeholder
        : '';
    },
    getInputDescription(field) {
      return field.attributes && field.attributes.description
        ? field.attributes.description
        : null;
    },
    getVariety(id) {
      const varieties = this.fields.seed_variety.options;
      return varieties.filter((variety) => id === variety.value).shift();
    },
    openFactors() {
      this.showFactors = !this.showFactors;
    },
    closeFactors() {
      this.showFactors = false;
    },
    isRequired(field) {
      return field.attributes && field.attributes.required;
    },
    isReadOnly(field) {
      return field.attributes && field.attributes.readonly;
    },
    maxLength(field) {
      return field.attributes && field.attributes.maxlength
        ? field.attributes.maxlength
        : null;
    },
    previousStep() {
      if (this.isFirstStep) return;
      this.currentStep -= 1;
      this.submitted = false;
    },
    nextStep() {
      if (this.isLastStep) return;

      this.validate();
      if (!this.isValid) return;

      this.currentStep += 1;
    },
    isArray(value) {
      return Array.isArray(value);
    },
    setSelectedTarget(event) {
      this.targetSelected = event.target.value;
      this.cleanErrorStatus();
    },
    cleanErrorStatus() {
      this.isValid = true;
      this.errorMessage = '';
    },
    validate() {
      // Seed Variety step.
      if (this.currentStep === 0 && !this.seedVariety) {
        this.isValid = false;
        this.errorMessage = 'Please select one of these options';
      }

      // Paddock step.
      if (
        this.currentStep === 1 &&
        (!this.fields.paddock_name.value ||
          !this.fields.paddock_area_sown.value)
      ) {
        this.isValid = false;
        this.errorMessage = 'Please fill out these fields';
      }

      // Target step.
      if (this.currentStep === 2) {
        if (!this.mainTarget) {
          this.isValid = false;
          this.errorMessage = 'Please fill out this field';
        } else if (!this.target) {
          this.isValid = false;
          this.errorMessage = 'Please select on of these options';
        }
      }

      // Paddock’s average germination rate step.
      if (this.currentStep === 3 && !this.fields.pa_germination_rate.value) {
        this.isValid = false;
        this.errorMessage = 'Please fill out this field';
      }
    },
    submit() {
      this.validate();
      if (!this.isValid) return;

      // Get submitted fields values.
      const submittedFields = {
        type: 'estimate-myseed',
        seedVariety: this.seedVariety,
        paddockName: this.fields.paddock_name.value,
        paddockSown: this.fields.paddock_area_sown.value,
        mainTarget: this.mainTarget,
        target: this.target,
        germinationRate: this.fields.pa_germination_rate.value,
      };

      // Set flags.
      this.submitted = true;
      this.currentStep += 1;

      const config = {
        params: submittedFields,
      };

      const url = `${this.domainUrl}/calculator/results/`;
      axios
        .get(url, config)
        .then((response) => {
          this.results = response.data;
          const variety = this.getVariety(this.seedVariety);
          this.results.product = {
            title: variety.label,
            text: variety.text,
            imageSrc: variety.image,
            imageAlt: variety.label,
          };
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
